module.exports = __webpack_public_path__ + "img/submenu05.56d7e6eb.png";